import Configs from "@/constants/configs";

/**
 * API URL 路径静态类
 * 集中管理所有API路径，便于维护和使用
 */
export class ApiUrls {
  // 基础路径前缀
  private static readonly BASE_URL = Configs.API_URL;
  private static readonly API_V1 = '/api/v1';

  // ================== 用户相关 APIs ===========================
  static readonly USER = {
    CHECK_DOMAIN: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/tenant/domain`,
    REGISTER: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/register`,
    LOGIN: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/login`,
    LOGOUT: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/logout`,
    UPDATE: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/update`,
    INFO: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/info`,
    TENANT_PERMISSIONS: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/tenant/permissions`,
    GET_ENCRYPT_KEY: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/getencrykey`,
    SEND_CODE: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/send-code`,
    SEARCH: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/search`,
    UPLOAD_URL: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/upload-url`,
    DOWNLOAD_URL: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/download-url`,
    QR_CODE_GET: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/qrcode/get`,
    QR_CODE_VERIFY: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/qrcode/:qr_id/verify`,
    QR_CODE_REFRESH: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/qrcode/refresh`,
    RESET_PASSWORD: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/reset-password`,
    UPLOAD_CONTACT_LIST: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/upload-contact-list`,
    PRESENCE: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/presence`,
    PRESENCE_BY_ID: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/user/presence/:user_id`,
  };

  // ================== 好友相关 APIs ===========================
  static readonly FRIEND = {
    ADD: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/friend/add`,
    REMOVE: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/friend/remove`,
    BLOCK: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/friend/block`,
    UNBLOCK: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/friend/unblock`,
    REPORT: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/friend/report`,
    UPDATE: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/friend/update`,
    BLOCK_LIST: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/friend/block/list`,
    LIST: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/friend/list`,
  };

  // ================== 群组相关 APIs ===========================
  static readonly GROUP = {
    CREATE: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/create`,
    UPDATE: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/:group_id/update`,
    INFO: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/:group_id/info`,
    LEAVE: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/:group_id/leave`,
    REMOVE_PARTICIPANTS: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/:group_id/participant/remove`,
    ADD_PARTICIPANTS: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/:group_id/participant/add`,
    PARTICIPANT_LIST: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/:group_id/participant/list`,
    PARTICIPANT_LIST_PAGINATED: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/:group_id/participant/list/paginated`,
    LIST: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/list`,
    DISBAND: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/:group_id/disband`,
    SET_ANNOUNCEMENT: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/:group_id/announcement`,
    REMOVE_ANNOUNCEMENT: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/:group_id/announcement`,
  };

  // ================== 聊天相关 APIs ===========================
  static readonly CHAT = {
    ABLY_TOKEN: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/ably/token`,
    DIRECT: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/chat/direct`,
    CONVERSATIONS: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/chat/conversations`,
    PIN_CONVERSATION: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/chat/conversations/:conversation_id/pin`,
    UNPIN_CONVERSATION: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/chat/conversations/:conversation_id/unpin`,
    GET_MESSAGES: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/chat/conversations/:conversation_id/messages`,
    UNACKED_MESSAGES: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/chat/conversations/:conversation_id/messages/unacked`,
    DELETE_MESSAGE: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/chat/conversations/:conversation_id/messages/:message_id`,
    DELETE_HISTORY: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/chat/conversations/:conversation_id/history/delete`,
    PIN_MESSAGE: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/:group_id/pin`,
    UNPIN_MESSAGE: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/group/:group_id/unpin`,
  };

  // ================== 翻译相关 APIs ===========================
  static readonly TRANSLATION = {
    SUPPORTED_LANGUAGES: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/translation/supported-languages`,
    TRANSLATE: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/translation/translate`,
  };

  // ================== 系统相关 APIs ===========================
  static readonly SYSTEM = {
    HEALTH_CHECK: `${ApiUrls.BASE_URL}${ApiUrls.API_V1}/health`,
  };

  // ================== 工具方法 ===========================

  // 获取带参数的URL
  static getUrl(url: string, params: Record<string, string | number>): string {
    let result = url;
    Object.keys(params).forEach(key => {
      result = result.replace(`:${key}`, String(params[key]));
    });
    return result;
  }
}
